import { useQuery } from '../../services/NetworkManager';
import { NetworkManager } from '../../services';

export function getAllPartners({ queryKey }) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, id, pageNo, pageSize, orderBy, order, search] = queryKey[0].split(',');

  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.partners,
    data: {
      currentPage: pageNo,
      pageSize,
      sortBy: orderBy,
      sortDir: order.toUpperCase(),
      searchPhrase: search,
      searchOn: ['firstName', 'lastName', 'email', 'phone', 'pan', 'panName'],
      filters: [
        {
          field: 'masterPartnerId',
          operation: 'EQUALS',
          value: id,
        },
        {
          field: 'masterPartnerUnlinkedOn',
          operation: 'IS_NULL',
        },
      ],
    },
  });
}

export function getPartnersSummary() {
  return NetworkManager.Call({
    method: 'get',
    path: NetworkManager.PATH.partnersSummaryData,
  });
}

export function getSubPartnerInvestments({ queryKey }) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, pageNo, pageSize, orderBy, order, search] = queryKey[0].split(',');
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.subPartnerInvestments,
    data: {
      currentPage: pageNo,
      pageSize,
      // sortBy: orderBy,
      // sortDir: order.toUpperCase(),
      sortBy: 'id',
      sortDir: 'DESC',
      searchPhrase: search,
      // searchOn: ["firstName", "lastName", "email", "phone", "pan"],
    },
  });
}
export function getSubPartnerInvestmentsCSVDownloadId({ queryKey }) {
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.csvSubPartnerInvestment,
    data: { filters: [] },
  });
}

// fetching the csv download id on click of download btn earlier we were fetching this id on page load and on success of this we are starting the polling api call
export async function requestSubPartnerInvestmentsCSVDownload(
  setShowDownloadProgress: (progress: number | null, totalItems: number | null) => void,
  filters?: Array<{ field: string; operation: string; value: string }>,
): Promise<{ downloadUrl: string }> {
  const computedFilters = filters ?? [];

  const response = await NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.csvSubPartnerInvestment,
    data: { filters: computedFilters },
  });
  const raw = response?.data ?? response;
  const downloadId = typeof raw === 'object' && raw !== null && 'id' in raw ? raw.id : raw;
  if (!downloadId) {
    throw new Error('Download ID not found');
  }
  return pollSubPartnerInvestmentsCSVDownloadLink(downloadId, setShowDownloadProgress);
}

// Polls subPartnerInvestmentsCSVDownloadLink until status is 'completed' and downloadUrl is present.
export async function pollSubPartnerInvestmentsCSVDownloadLink(
  downloadId: string,
  setShowDownloadProgress: (progress: number | null, totalItems: number | null) => void,
): Promise<{ downloadUrl: string }> {
  const path = NetworkManager.PATH.subPartnerInvestmentsCSVDownloadLink.replace(
    '{{download-id}}',
    downloadId,
  );

  while (true) {
    const response = await NetworkManager.Call({
      method: 'get',
      path,
    });

    const downloadApiResponse = response?.data ?? response;
    const { status, downloadUrl, progress, totalItems } = downloadApiResponse || {};
    setShowDownloadProgress(progress, totalItems);

    if (status === 'COMPLETED' && downloadUrl) {
      return { downloadUrl };
    } else if (status === 'FAILED') {
      throw new Error('The CSV generation failed on the server.');
    }

    await new Promise((r) => setTimeout(r, 500));
  }
}

export function usePartners({ payload }) {
  const { id, pageNo, pageSize, orderBy, order, search } = payload;
  const { data, isLoading, refetch } = useQuery(
    `${['partners', id, pageNo, pageSize, orderBy, order, search]}`,
    getAllPartners,
    { enabled: !!id },
  );
  return { data, isLoading, refetch };
}

export function usePartnersSummary() {
  const { data, isLoading, refetch } = useQuery('partnersSummary', getPartnersSummary);
  return { data, isLoading, refetch };
}

export function useSubPartnerInvestments({ pageNo, pageSize, orderBy, order, search }) {
  const { data, isLoading } = useQuery(
    `${['subPartnerInvestments', pageNo, pageSize, orderBy, order, search]}`,
    getSubPartnerInvestments,
  );
  return { data, isLoading };
}

// Add partner API's
export function getPartnerKycDetails({ partnerId, setPartnerDetails }) {
  return NetworkManager.Call({
    method: 'get',
    path: NetworkManager.PATH.getPartnerKycDetails.replace('{{subPartnerPublicId}}', partnerId),
  }).then((res) => {
    setPartnerDetails((prev) => ({ ...prev, kycStatus: res?.data }));
  });
}
